export var hasEnoughSeatbelts = function (transport) {
    var nbOfSeatBelts = transport.nbOfSeatBelts, nbOfPassengers = transport.nbOfPassengers;
    return nbOfPassengers + 2 <= nbOfSeatBelts;
};
